import { FC, useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider";
import "./Authorization.scss";
import { useStyle } from "../../providers/StyleProvider";
import { useUsers } from "../../providers/Access/Users/UsersProvider";
import useIsMobileApp from "../../hooks/useIsMobileApp";
import { getPostLoginPath } from "../../utils/MobileChatRedirect";

interface AuthorizationProps {}

const Authorization: FC<AuthorizationProps> = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobileApp();

  const { token, domain } = useParams();
  const { authorization, setOrigin, tokenLacqua } = useAuth();
  const { urlDomus } = useStyle();
  const { handleStatusTutorial } = useUsers();

  const [notAuthorization, setNotAuthorization] = useState<any>(false);
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect");
  const mainNav = searchParams.get("mainNav");
  const _tokenLacqua = searchParams.get("token_lacqua");
  const _origin = searchParams.get("origin");

  useEffect(() => {
    if (token && domain) {
      authorization({ assertion: token, domain: domain }).then((res) => {
        let _url =
          process.env.REACT_APP_ENV !== "production"
            ? process.env.REACT_APP_DOMUS_DEV
            : `sistema.bevicred.com.br`;

        if (_origin === "lacqua.app" || _origin === "homolog.lacqua.app") {
          _url = process.env.REACT_APP_DOMUS_DEV?.replace(
            "https://",
            "",
          )?.replace("http://", "");
        }

        setOrigin(_url || "");
        localStorage.setItem("@beviAjudaGui:tokenLacqua", `${_tokenLacqua}`);

        if (res?.success) {
          handleStatusTutorial();
          const mobileChatPath = getPostLoginPath(res?.user, isMobile, "");
          if (mobileChatPath) {
            // Mobile: sempre cai direto no chat da IA.
            navigate(mobileChatPath);
          } else if (redirect) {
            navigate(`/${redirect}${mainNav ? `?mainNav=${mainNav}` : ""}`);
          } else {
            navigate("/");
          }
        } else {
          setNotAuthorization(true);
        }
      });
    }
  }, [token, domain]);

  return (
    <>
      {notAuthorization && (
        <main
          className="Authorization main-content main-content-bg mt-0 h-100-vh"
          data-testid="Authorization"
        >
          <Container>
            <Row className="justify-content-center">
              <Col lg={6} md={7} className="mx-auto text-center">
                <h1 className="display-1 text-bolder text-primary">
                  Error 401
                </h1>
                <h2>Página não autorizada</h2>
                <p className="lead">Token inválido ou não autorizado.</p>

                <a
                  href={
                    urlDomus && tokenLacqua
                      ? `${urlDomus}/app/api/v1/auth/authTokenSB?token=${tokenLacqua}`
                      : `${process.env.REACT_APP_DOMUS_DEV}`
                  }
                >
                  <Button className="btn btn-primary text-white mt-4 fadeIn2 fadeInBottom">
                    Voltar para o login
                  </Button>
                </a>
              </Col>
            </Row>
          </Container>
        </main>
      )}
    </>
  );
};

export default Authorization;
